// extracted by mini-css-extract-plugin
module.exports = {"left":"_3QZR9","authorHeader":"tqBut","titleHeader":"_7MH2x","moreButtonHeader":"dlzDQ"};